import { render, staticRenderFns } from "./CenterSchoolModal.vue?vue&type=template&id=c4498040&scoped=true"
import script from "./CenterSchoolModal.vue?vue&type=script&lang=js"
export * from "./CenterSchoolModal.vue?vue&type=script&lang=js"
import style0 from "./CenterSchoolModal.vue?vue&type=style&index=0&id=c4498040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4498040",
  null
  
)

export default component.exports